import React, { useEffect, useState } from 'react'
import './Productstraking.css'
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import './loader.css'

const Productstraking = () => {
    const order_id = secureLocalStorage.getItem("orderid");
    const token = secureLocalStorage.getItem("n_token");

    const [showorderlist, setshoworderlist] = useState([]);

    useEffect(() => {
        if (!order_id) return;

        const fetchOrder = async () => {
            try {
                const { data } = await axios.post(
                    `${process.env.REACT_APP_API}website/track_my_order`,
                    { order_id },
                    { headers: { token } }
                );

                setshoworderlist(data.data || []);
            } catch (error) {
                console.error("Order Tracking Error:", error);
            }
        };

        fetchOrder();
    }, [order_id]);  // ✅ ONLY `order_id`

    return (
        <div>
            {showorderlist.length > 0 ? (
                <div style={{ zIndex: "0" }}>
                    <div className="info">
                        <div className="row">
                            <div className="col-7">
                                <span id="heading"><b>Order Date</b></span><br />
                                <span id="details">{showorderlist[0]?.order_date}</span>
                            </div>
                            <div className="col-5 pull-right">
                                <span id="heading"><b>Order ID</b></span><br />
                                <span id="details">{showorderlist[0]?.order_no}</span>
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-7">
                                <span id="heading"><b>Payment mode</b></span><br />
                                <span id="details">{showorderlist[0]?.payment_mode}</span>
                            </div>
                            <div className="col-5 pull-right">
                                <span id="heading"><b>Total</b></span><br />
                                <span id="details">₹{showorderlist[0]?.grand_total}</span>
                            </div>
                        </div>
                    </div>

                    <div className="tracking">
                        <div className="title">Tracking Order</div>
                    </div>

                    {/* ✅ Status UI */}
                    {showorderlist[0]?.order_status === "In Progress" && (
                        <div className="progress-track">
                            <ul id="progressbar">
                                <li className="step0 active" style={{ fontSize: "15px" }} >Pending</li>
                                <li className="step0 active" style={{ fontSize: "15px" }}>In Progress</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Cancel</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Complete</li>
                            </ul>
                        </div>
                    )}

                    {showorderlist[0]?.order_status === "Pending" && (
                        <div className="progress-track">
                            <ul id="progressbar">
                                <li className="step0 active" style={{ fontSize: "15px" }}>Pending</li>
                                <li className="step0" style={{ fontSize: "15px" }}>In Progress</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Cancel</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Complete</li>
                            </ul>
                        </div>
                    )}

                    {showorderlist[0]?.order_status === "Cancel" && (
                        <div className="progress-track">
                            <ul id="progressbar">
                                <li className="step0" style={{ fontSize: "15px" }}>In Progress</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Pending</li>
                                <li className="step0 active text-danger" style={{ fontSize: "15px" }}>Canceled</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Completed</li>
                            </ul>
                        </div>
                    )}

                    {showorderlist[0]?.order_status === "Completed" && (
                        <div className="progress-track">
                            <ul id="progressbar">
                                <li className="step0" style={{ fontSize: "15px" }}>In Progress</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Pending</li>
                                <li className="step0" style={{ fontSize: "15px" }}>Cancel</li>
                                <li className="step0 active text-success" style={{ fontSize: "15px" }}>Completed</li>
                            </ul>
                        </div>
                    )}
                </div>
            ) : (
                <div className="row justify-content-center pb-5">
                    <div className="loader"></div>
                </div>
            )}
        </div>
    );
};

export default Productstraking;
